import { httpClient } from '../httpClient';

/**
 * Classification Review API -- review operations + review center.
 * Extracted from classification.js (T117).
 */
export const classificationReviewApi = {
  // ── Reviews ────────────────────────────────────────────────────────────
  getReviewItems: (queryString) =>
    httpClient.get(`/classification/reviews?${queryString}`),

  // ── Review Center ──────────────────────────────────────────────────────
  getClassificationsForReview: (queryString) =>
    httpClient.get(`/classification/reviews/all?${queryString}`),

  acceptClassification: (classificationId, body) =>
    httpClient.post(`/classification/reviews/accept/${classificationId}`, body || {}),

  rejectClassification: (classificationId, data) =>
    httpClient.post(`/classification/reviews/reject/${classificationId}`, data),

  overrideClassification: (classificationId, data) =>
    httpClient.post(`/classification/reviews/override/${classificationId}`, data),

  batchAccept: (data) =>
    httpClient.post('/classification/reviews/batch-accept', data),

  // --- Review Center: Campaigns ---
  createCampaign: (data) =>
    httpClient.post('/classification/campaigns', data),

  listCampaigns: (queryString) =>
    httpClient.get(`/classification/campaigns?${queryString}`),

  getCampaign: (id) =>
    httpClient.get(`/classification/campaigns/${id}`),

  updateCampaign: (id, data) =>
    httpClient.put(`/classification/campaigns/${id}`, data),

  launchCampaign: (id, data) =>
    httpClient.post(`/classification/campaigns/${id}/launch`, data),

  completeCampaign: (id) =>
    httpClient.post(`/classification/campaigns/${id}/complete`),

  deleteCampaign: (id) =>
    httpClient.delete(`/classification/campaigns/${id}`),

  cancelCampaign: (id) =>
    httpClient.post(`/classification/campaigns/${id}/cancel`),

  getCampaignItems: (id, queryString) =>
    httpClient.get(`/classification/campaigns/${id}/items?${queryString}`),

  assignCampaignReviewers: (id, data) =>
    httpClient.post(`/classification/campaigns/${id}/assign`, data),

  // --- Review Center: Assignment & SLA ---
  assignReviewItem: (data) =>
    httpClient.post('/classification/reviews/assign', data),

  selfAssignReview: (data) =>
    httpClient.post('/classification/reviews/assign-me', data),

  unassignReview: (data) =>
    httpClient.post('/classification/reviews/unassign', data),

  getMyReviewQueue: (queryString) =>
    httpClient.get(`/classification/reviews/my-queue?${queryString}`),

  batchRejectClassifications: (data) =>
    httpClient.post('/classification/reviews/batch-reject', data),

  getSLAConfig: () =>
    httpClient.get('/classification/reviews/sla-config'),

  updateSLAConfig: (data) =>
    httpClient.put('/classification/reviews/sla-config', data),

  getAssignmentRules: () =>
    httpClient.get('/classification/reviews/assignment-rules'),

  updateAssignmentRules: (data) =>
    httpClient.put('/classification/reviews/assignment-rules', data),

  applyAssignmentRules: () =>
    httpClient.post('/classification/reviews/assignment-rules/apply'),

  getWorkload: () =>
    httpClient.get('/classification/reviews/workload'),

  updateCapacity: (userId, data) =>
    httpClient.put(`/classification/reviews/capacity/${userId}`, data),

  // --- Review Center: Simulation ---
  runSimulation: (data) =>
    httpClient.post('/classification/reviews/simulate', data),

  getSimulationDiff: (queryString) =>
    httpClient.get(`/classification/reviews/simulate/diff?${queryString}`),

  applySimulation: (data) =>
    httpClient.post('/classification/reviews/simulate/apply', data),

  // --- Review Center: Similar Items ---
  getSimilarItems: (classificationId) =>
    httpClient.get(`/classification/reviews/${classificationId}/similar`),

  batchAcceptSimilar: (data) =>
    httpClient.post('/classification/reviews/batch-accept-similar', data),
};
